<script setup lang="ts">
import { type PropType } from 'vue'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

defineProps({
	pageContent: {
		type: Object as PropType<{
			[key: string]: string
		}>,
		required: true,
	},
	listShoppingDetail: {
		type: Array as PropType<
			{
				icon: string
				text: string
				action: () => void
			}[]
		>,
		required: true,
	},
})
</script>

<template>
	<h2
		class="typography-h5-str mb-24px mt-48px text-n-950 mdp:mb-good-friends mdp:mt-0"
	>
		{{ pageContent.detail_shopping_details_title }}
	</h2>
	<div class="flex flex-col rounded-lg bg-n-50 p-16px">
		<div
			class="flex cursor-pointer flex-wrap items-center justify-between"
			v-for="(item, index) in listShoppingDetail"
			:key="item.icon"
			@click="item.action"
		>
			<div class="flex flex-1 items-center gap-16px">
				<div class="h-24px w-24px">
					<BaseIcon :name="item.icon" class="h-full w-full"></BaseIcon>
				</div>
				<p class="typography-s2-emp flex-1 text-n-950">
					{{ item.text }}
				</p>
			</div>
			<div class="ml-16px h-24px w-24px">
				<BaseIcon
					name="arrow_right_full"
					class="h-full w-full fill-n-950"
				></BaseIcon>
			</div>
			<div
				class="my-16px h-[1px] w-full basis-full bg-n-100"
				v-if="index !== listShoppingDetail.length - 1"
			></div>
		</div>
	</div>
</template>
